import { render } from "./UrlSection.vue?vue&type=template&id=75c4fa3c&scoped=true"
import script from "./UrlSection.vue?vue&type=script&lang=js"
export * from "./UrlSection.vue?vue&type=script&lang=js"

import "./UrlSection.vue?vue&type=style&index=0&id=75c4fa3c&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c4fa3c"]])

export default __exports__